<template>
  <div id="layChinCList">
    <div class="left_Title">
      <p>
        <i class="iconfont iconjieguo"></i>
        <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') +'&nbsp;'+ '(' + total + ')'  |U2M}}</span>
      </p>
      <p></p>
    </div>
    <div v-if="!isNo" class="list_Content aqt_no_su" ref="Content_Width">
      <div class="aqt_list_lists_one" v-for="(item,index) in list" :key="index">
        <div class="aqt_top ">
          <i class="iconfont iconyuanquan"></i>
        </div>
        <div class="aqt_center">
          <p v-if="item.titlelang && item.titlelang.mn" class="p titlefont aqt_lang_mn" v-html="U2M(item.titlelang.mn.trim())"></p>
          <p v-else class="p titlefont aqt_su" v-html="U2M(item.titlelang ? item.titlelang.zh ? item.titlelang.zh.trim(): '' : '')"></p>
        </div>
      </div>
    </div>
    <div class="page">
      <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
      <!-- <Page v-if="!isNo"  :total="total" :current="current_page" 
            :page-size="per_page"
            @on-change="getPager"/> -->
    </div>
    <div v-if="isNo&&!list.length" class="nomassage">
      <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
    </div>
    <!--    加载动画-->
    <AqtSpin v-if="isSpin"></AqtSpin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      booksSearch: {
        title: '',//书名
        lang: 'mn',
        page: 1,
        per_page: '',
        class_id: '',//152 谚语 151对联 153谜语
      },
      isSpin: false,
    }
  },
  methods: {
    /******************************************
     *
     *分页器
     *
     *****************************************/
    getPager(page) {
      let that = this
      that.list = []
      that.booksSearch.page = page
      that.getList()
    },
    getList() {
      let that = this
      that.isSpin = true
      that.list = []
      //保存用户搜索记录
      that.$store.commit('SET_PuserSearch', [JSON.stringify(that.booksSearch), that.$route.path, that.$route.meta.title, 9],)
      that.$store.dispatch('getHedcircle')
      that.$httpsencrypt.post(`api/web/v3/cihai/listweb`, that.booksSearch)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1

              if (that.booksSearch.title) {
                val.data.forEach((item) => {
                  var arr = item.titlelang.mn.split(" ");
                  arr.forEach((elem, index) => {
                    var strarr = that.booksSearch.title.split(' ')
                    strarr.forEach(it => {
                      if (it == '') {
                        return
                      }
                      var i = elem.indexOf(it.trim());

                      if (i > -1) {
                        var replacestr =
                            '<span style="color:var(--themeColor)!important;">' +
                            arr[index] +
                            "</span>";
                        arr[index] = replacestr;
                      }

                    })
                  });
                  item.titlelang.mn = arr.join(" ");
                });
              }

              that.list = val.data
              that.getWidth()
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              thst.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    getWidth() {
      let _this = this
      setTimeout(() => {
        _this.$nextTick(() => {
          const boxindex = document.querySelectorAll('.p');
          const contentList = document.querySelectorAll('.aqt_center');
          const boxlist = document.querySelectorAll('.aqt_list_lists_one');

          for (let i = 0; i < boxindex.length; i++) {
            boxindex[i].style.width = boxindex[i].offsetWidth + 'px'
            contentList[i].style.minWidth = boxindex[i].offsetWidth + 'px'
            boxlist[i].style.minWidth = boxindex[i].offsetWidth + 15 + 'px'
          }
        })
      }, 300);
    },
    //父组件调用请求数组
    ParentCom(val){
      let that = this
      that.isNo = false
      that.booksSearch.title=val.title
      that.booksSearch.class_id=val.class_id
      that.getList()
    },
  },

  created() {
    let info={
      type: 1,
      path: this.$route.path,
      mark: '谚语、对联、谜语列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
    let that = this
    let kk = that.$refs.Content_Width.clientWidth / 45.2
    that.booksSearch.per_page = Math.floor(kk)
  }
}
</script>
<style lang="less" scoped>
#layChinCList {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .contentfonts1 {
    font-size: 1.6rem;
  }

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
  }

  .left_Title {
    width: 54px;
    height: 100%;
    background: #ffffff;
    margin-right: 2px;
    padding-top: 27px;
    display: flex;
    justify-content: flex-end;

    p:nth-child(1) {
      width: 24px;
      color: var(--themeColor);
      font-size: 20px;
      line-height: 24px;

      i {
        font-size: 24px;

      }
    }

    p:nth-child(2) {
      width: 8px;
      height: 162px;
      background: var(--themeColor);
      margin-left: 10px;
    }
  }

  .list_Content {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    overflow-x: auto !important;

    .aqt_list_lists_one {
      //width: 60px;
      height: 100%;
      background-color: #ffffff;
      margin-right: 0.2rem;
      //cursor: pointer;
      overflow: hidden;

      .aqt_top {
        height: 40px;
        width: 100%;
        padding: 20px 0 0 0px;
        display: flex;
        justify-content: center;

        i {
          font-size: 20px;
          color: var(--themeColor);
        }
      }

      .aqt_center {
        height: calc(100% - 40px);
        padding-top: 1rem;
        display: flex;
        overflow: hidden;

        .aqt_lang_mn1 {
          writing-mode: vertical-lr;
        }
        p {
          height: calc(100% - 0.5rem);
          font-size: 20px;
          color: #888888;
          line-height: 22.5px;
          overflow: hidden;
          white-space: pre-line;
          margin: 0 auto;
        }
        //.aqt_title {
        //  width: 3.4rem;
        //  height: calc(100% - 1rem);
        //  color: #000000;
        //  font-size: 1.8rem;
        //  margin: 0 0.5rem;
        //
        //  p {
        //    white-space: nowrap;
        //    -o-text-overflow: ellipsis;
        //    text-overflow: ellipsis;
        //    overflow: hidden;
        //    margin: 0 auto;
        //    height: 100%;
        //  }
        //}
        //
        //.aqt_zhengzhuang {
        //  height: calc(100% - 3.4rem);
        //  width: calc(100% - 3.5rem);
        //  p {
        //    display: flex;
        //    flex-direction: column;
        //    color: #888888;
        //    font-size: 1.6rem;
        //    line-height: 1.6rem;
        //    i{
        //      font-size: 16px;
        //      margin-bottom: 0.5rem;
        //    }
        //  }
        //  p:nth-child(1){
        //    height: 180px;
        //  }
        //  p:nth-child(2){
        //    height: calc(100% - 180px);
        //    white-space: nowrap;
        //    -o-text-overflow: ellipsis;
        //    text-overflow: ellipsis;
        //    overflow: hidden;
        //  }
        //}
      }

      .aqt_bottom_img {
        width: 100%;
        height: 20px;

        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }

  .list_Content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  .list_Content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .list_Content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .page {
    width: 50px;
    height: 100%;
  }
}
</style>

